module.exports = __webpack_public_path__ + "static/media/ZEHUB.5b374bc7.svg";